import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, Product, ProductWrite } from 'types';
import { client } from 'utils/api-client';

export default function useUpdateProduct(): UseMutationResult<
  AxiosResponse<Product>,
  AxiosError<ErrorMessage>,
  Omit<ProductWrite, 'file'> & { file: File | null }
> {
  const queryClient = useQueryClient();

  const updateProduct = (
    payload: Omit<ProductWrite, 'file'> & { file: File | null },
  ): Promise<AxiosResponse<Product>> => {
    const formData = new FormData();
    formData.append('file', payload.file || '');
    formData.append('price', payload.price.toString());
    formData.append('tax_rate', payload.taxRate || '');
    formData.append('name', payload.name);
    formData.append('is_favorite', payload.isFavorite.toString());
    formData.append('product_id', payload.productId);
    formData.append('type', payload.type);
    return client.put(`products/${payload.productId}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

  return useMutation(updateProduct, {
    onSuccess: () => {
      queryClient.invalidateQueries(['products']);
    },
  });
}
